/* ============================================================
   HAWAII SUPPLY CO — POKEMON TCG HOMEPAGE LOGIC
   Loaded (deferred) by sections/hsc-pokemon-home.liquid.

   Architecture notes:
   - init(root) wires up one instance and returns a cleanup function.
     boot() runs cleanup before re-initializing, so Theme Editor
     section reloads (shopify:section:load) never stack duplicate
     document/window listeners or leak timers.
   - window.fetch is wrapped ONCE (guarded) because Horizon's cart
     drawer does not emit reliable public events; watching the cart
     endpoints is the only dependable way to react instantly to
     drawer edits. The wrapper only notifies a replaceable hook
     (window.__hscCartMutated) — behavior of fetch is untouched.
   - Element-scoped listeners die with their DOM nodes; only
     document/window listeners need explicit cleanup.
   ============================================================ */
(function () {
  /* If the Theme Editor re-injects this script on a section reload, bail —
     the first instance's shopify:section:load listener handles re-init. */
  if (window.__hscScriptLoaded) return;
  window.__hscScriptLoaded = true;

  var CONFIG = {
    /* Tabs are driven by collections — add/remove products in Shopify admin. */
    collections: {
      boxes: "pokemon-tcg-japanese-booster-boxes",
      packs: "pokemon-tcg-japanese-booster-packs",
      singles: "pokemon-singles"
    },
    maxQty: { boxes: 10, packs: 30, singles: 5 },
    lowStockThreshold: 2,
    modalCloseMs: 400,
    freeShipCents: 22500, /* $225 free-shipping threshold */
    /* Tags that describe the product (never rendered as a badge pill). */
    badgeTagExclude: ["booster box", "booster pack", "japanese", "mega", "pokemon", "sealed", "single card"],
    emptyCopy: {
      packs: { h: "Single packs are coming soon.", p: "We’re cracking boxes shortly — grab a sealed box in the meantime." },
      singles: { h: "Singles are coming soon.", p: "Fresh pulls get listed here — check back after the next box break." }
    }
  };

  /* ---- one-time global fetch watch (see architecture notes) ---- */
  if (!window.__hscFetchWrapped) {
    window.__hscFetchWrapped = true;
    var origFetch = window.fetch;
    window.fetch = function () {
      var arg = arguments[0];
      var url = (arg && typeof arg === "object" && arg.url) ? arg.url : String(arg || "");
      var p = origFetch.apply(window, arguments);
      if (/\/cart\/(add|change|update|clear)/.test(url)) {
        p.then(function () {
          if (typeof window.__hscCartMutated === "function") window.__hscCartMutated();
        }, function () { /* network failure: nothing to sync */ });
      }
      return p;
    };
  }

  function money(cents) { return "$" + (cents / 100).toFixed(2); }

  function shortName(t) {
    return t.replace(/^Pokemon TCG Japan:\s*/i, "").replace(/\s*-\s*Japanese\s*$/i, "");
  }

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  }

  /* ============================ init ============================ */
  function init(root) {
    var docListeners = [];  /* [target, type, fn] for cleanup */
    var timers = { toast: null, sync: null };

    function on(target, type, fn) {
      target.addEventListener(type, fn);
      docListeners.push([target, type, fn]);
    }

    /* ---- element handles (IDs are unique to this section) ---- */
    var grid = document.getElementById("hscGrid"),
        wrap = document.getElementById("hscWrap"),
        seg = document.getElementById("hscSeg"),
        sortSel = document.getElementById("hscSort"),
        toastEl = document.getElementById("hscToast"),
        toastTxt = document.getElementById("hscToastTxt"),
        toastFill = document.getElementById("hscToastFill");

    var mback = document.getElementById("hscMback"),
        modal = document.getElementById("hscModal"),
        mclose = document.getElementById("hscMclose"),
        mimg = document.getElementById("hscMimg"),
        mbadges = document.getElementById("hscMbadges"),
        mtitle = document.getElementById("hscMtitle"),
        mprice = document.getElementById("hscMprice"),
        mdesc = document.getElementById("hscMdesc"),
        mn = document.getElementById("hscMn"),
        madd = document.getElementById("hscMadd"),
        mswitch = document.getElementById("hscMswitch");

    /* ---- state ---- */
    var CART_QTY = {};                       /* variant id -> qty in cart */
    var mVariant = null, mMax = 10, mHandle = null, mOpener = null;
    var mImgs = [];                          /* [0]=box photo, [1]=chase card */
    var curView = null, lastItems = [];

    /* Per-product data rendered server-side by Liquid (see the section file). */
    var HSC_DATA = (function () {
      var el = document.getElementById("hscProductData");
      if (!el) return {};
      try { return JSON.parse(el.textContent) || {}; }
      catch (e) { console.warn("[hsc] bad product data:", e); return {}; }
    })();

    /* ---- responsive add-button labels ---- */
    var mqSmall = window.matchMedia("(max-width:640px)");
    function addLabel() { return mqSmall.matches ? "Add" : "Add To Cart"; }
    if (mqSmall.addEventListener) {
      var mqFn = function () { paintAllAddButtons(); };
      mqSmall.addEventListener("change", mqFn);
      docListeners.push([mqSmall, "change", mqFn]);
    }

    /* ---- cart-state button painting ---- */
    function paintAddButton(btn) {
      /* Skip buttons that are mid-request, sold out, or "Notify Me". */
      if (btn.disabled || btn.classList.contains("hsc-notify") || !btn.dataset.variant) return;
      var n = CART_QTY[btn.dataset.variant] || 0;
      if (n > 0) {
        /* In cart: "(N)" plus the green Pokéball (CSS ::after on .incart). */
        btn.classList.add("incart"); btn.classList.remove("done");
        btn.textContent = "(" + n + ")";
      } else {
        btn.classList.remove("incart", "done");
        btn.textContent = addLabel();
      }
    }
    function paintAllAddButtons() {
      var btns = root.querySelectorAll(".hsc-add");
      for (var i = 0; i < btns.length; i++) paintAddButton(btns[i]);
      if (madd) paintAddButton(madd);
    }

    /* ---- reveal-on-scroll ---- */
    var io = ("IntersectionObserver" in window) ? new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add("in"); io.unobserve(e.target); }
      });
    }, { threshold: .12 }) : null;
    function watch(el) { if (io) io.observe(el); else el.classList.add("in"); }
    root.querySelectorAll(".rv").forEach(watch);

    /* ---- product normalization ---- */
    function norm(p) {
      var v = p.variants[0];
      var rec = HSC_DATA[p.handle] || {};
      return {
        handle: p.handle,
        title: p.title,
        img: (p.images && p.images[0]) ? (p.images[0].src || p.images[0]) : "",
        variantId: v.id,
        priceCents: (typeof v.price === "string") ? Math.round(parseFloat(v.price) * 100) : v.price,
        available: (v.available !== undefined) ? v.available : true,
        tags: (p.tags || []),
        inventoryQty: (typeof rec.q === "number") ? rec.q : null,
        subtitle: rec.m || "",
        createdAt: (Date.parse(p.published_at || p.created_at || "") || 0)
      };
    }

    /* ---- badges ---- */
    function badgesFor(p) {
      var badges = [];
      p.tags.forEach(function (t) {
        var trimmed = t.trim();
        if (!trimmed) return;
        var lower = trimmed.toLowerCase();
        if (CONFIG.badgeTagExclude.indexOf(lower) !== -1) return;
        badges.push({ label: trimmed, cls: (lower === "new") ? "hsc-badge-new" : "" });
      });
      if (p.available && p.inventoryQty !== null && p.inventoryQty <= CONFIG.lowStockThreshold) {
        badges.push({ label: "Low", cls: "hsc-badge-low" });
      }
      return badges;
    }
    function badgesHtmlFor(p) {
      return badgesFor(p).map(function (b) {
        return '<span class="' + b.cls + '">' + b.label + '</span>';
      }).join("");
    }

    /* ---- fly-to-cart: the caught green Pokéball warps to the cart icon ---- */
    function cartTargetPoint() {
      var el = document.querySelector("cart-icon");
      if (!el) {
        var links = document.querySelectorAll('header a[href*="/cart"], a[href="/cart"]');
        if (links.length) el = links[0];
      }
      if (el) {
        var r = el.getBoundingClientRect();
        if (r.width > 0 || r.height > 0) return { x: r.left + r.width / 2, y: r.top + r.height / 2 };
      }
      /* Fallback: top-right corner, where the cart icon lives. */
      return { x: window.innerWidth - 30, y: 30 };
    }
    function flyToCart(originEl) {
      if (prefersReducedMotion()) return;
      if (!originEl || !originEl.getBoundingClientRect) return;
      var r = originEl.getBoundingClientRect();
      if (r.width === 0 && r.height === 0) return;
      var t = cartTargetPoint();
      var fly = document.createElement("div");
      fly.className = "hsc-fly";
      fly.setAttribute("aria-hidden", "true");
      var cx = r.left + r.width / 2, cy = r.top + r.height / 2;
      fly.style.left = (cx - 15) + "px";
      fly.style.top = (cy - 15) + "px";
      document.body.appendChild(fly);
      requestAnimationFrame(function () { requestAnimationFrame(function () {
        fly.style.transform = "translate(" + (t.x - cx) + "px, " + (t.y - cy) + "px) rotate(340deg) scale(.2)";
        fly.style.opacity = "0.3";
      }); });
      setTimeout(function () { if (fly.parentNode) fly.parentNode.removeChild(fly); }, 1050);
    }

    /* ---- tell the rest of the theme the cart changed ---- */
    var cartEventsModule = null;
    function notifyThemeCartUpdated(cart) {
      /* Primary: Horizon's <cart-icon> exposes renderCartBubble(count). */
      document.querySelectorAll("cart-icon").forEach(function (el) {
        if (typeof el.renderCartBubble === "function") {
          try { el.renderCartBubble(cart.item_count); }
          catch (e) { console.warn("[hsc] cart-icon update failed:", e); }
        }
      });
      /* Secondary, best-effort: dispatch Shopify's standard cart event so an
         open cart drawer can refresh too. */
      var promise = Promise.resolve({
        cart: { totalQuantity: cart.item_count },
        detail: { itemCount: cart.item_count, sections: cart.sections, source: "hsc-pokemon-home" }
      });
      (cartEventsModule ? Promise.resolve(cartEventsModule) : import("https://cdn.shopify.com/storefront/standard-events.js"))
        .then(function (mod) {
          cartEventsModule = mod;
          document.dispatchEvent(new mod.CartLinesUpdateEvent({
            action: "add", context: "hsc-pokemon-home", lines: [], promise: promise
          }));
        })
        .catch(function (e) { console.warn("[hsc] standard cart event dispatch skipped:", e); });
    }

    /* ---- free-shipping toast (5s, slides in from the right edge) ---- */
    function showShipToast(totalCents) {
      toastFill.style.width = Math.min(100, totalCents / CONFIG.freeShipCents * 100) + "%";
      if (totalCents >= CONFIG.freeShipCents) {
        toastEl.classList.add("free");
        toastTxt.textContent = "Free shipping unlocked!";
      } else {
        toastEl.classList.remove("free");
        toastTxt.textContent = money(CONFIG.freeShipCents - totalCents) + " away from free shipping";
      }
      toastEl.classList.add("show");
      clearTimeout(timers.toast);
      timers.toast = setTimeout(function () { toastEl.classList.remove("show"); }, 5000);
    }

    /* ---- cart state sync ---- */
    function updateCartUI(c, announce) {
      CART_QTY = {};
      (c.items || []).forEach(function (it) {
        CART_QTY[it.variant_id] = (CART_QTY[it.variant_id] || 0) + it.quantity;
      });
      paintAllAddButtons();
      if (announce && c.item_count) showShipToast(c.total_price || 0);
      if (!c.item_count) toastEl.classList.remove("show");
    }
    function refreshCart(announce) {
      fetch("/cart.js")
        .then(function (r) { return r.json(); })
        .then(function (c) { updateCartUI(c, announce); })
        .catch(function () { /* transient; next sync will catch up */ });
    }
    /* Debounced so bursts of cart events cause a single /cart.js fetch. */
    function syncCartSoon(announce) {
      clearTimeout(timers.sync);
      timers.sync = setTimeout(function () { refreshCart(announce); }, 50);
    }

    /* ---- add to cart: spinning ball → green catch → warp → "(N)" ---- */
    function addToCart(variantId, qty, btn, onSuccess) {
      if (btn.disabled) return;
      btn.disabled = true;
      btn.classList.remove("incart");
      btn.classList.add("busy", "ball");
      btn.textContent = "Adding…";
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: qty }] })
      }).then(function (r) {
        return r.json().then(function (data) {
          if (!r.ok) throw new Error(data && data.message ? data.message : "Couldn't add to cart.");
          return data;
        });
      }).then(function () {
        return fetch("/cart.js").then(function (r) { return r.json(); });
      }).then(function (cart) {
        btn.classList.add("caught");
        notifyThemeCartUpdated(cart);
        /* Let the catch register for a beat, then warp the green ball
           from the button up to the cart icon. */
        setTimeout(function () { flyToCart(btn); }, 250);
        setTimeout(function () {
          btn.classList.remove("busy", "ball", "caught");
          btn.disabled = false;
          updateCartUI(cart, true);
          if (onSuccess) onSuccess();
        }, 600);
      }).catch(function (err) {
        btn.classList.remove("busy", "ball", "caught", "done");
        btn.textContent = "Try again";
        btn.disabled = false;
        console.error("[hsc] add to cart failed:", err);
      });
    }

    /* ---- back-in-stock ("Notify Me") email capture ----
       Posts Shopify's storefront customer form, creating/updating a customer
       tagged restock:<handle>. A daily job emails them when stock returns. */
    function bisNode(handle) {
      var f = document.createElement("form");
      f.className = "hsc-bisform";
      f.innerHTML = '<input type="email" required placeholder="you@email.com" aria-label="Email address"><button type="submit">Notify</button>';
      f.addEventListener("submit", function (ev) {
        ev.preventDefault();
        var em = f.querySelector("input").value;
        var body = "form_type=customer&utf8=%E2%9C%93" +
          "&contact%5Bemail%5D=" + encodeURIComponent(em) +
          "&contact%5Btags%5D=" + encodeURIComponent("restock:" + handle) +
          "&return_to=%2F";
        function swap(text, ok) {
          var d = document.createElement("div");
          d.className = "hsc-bisok";
          if (!ok) d.style.color = "#c62b08";
          d.textContent = text;
          if (f.parentNode) f.parentNode.replaceChild(d, f);
        }
        fetch("/contact", {
          method: "POST",
          headers: { "Content-Type": "application/x-www-form-urlencoded", "Accept": "text/html" },
          body: body
        }).then(function (r) {
          /* Shopify answers a successful signup with a redirect to return_to.
             A redirect to /challenge means the bot check intercepted it. */
          if (r.url && r.url.indexOf("challenge") > -1) {
            console.warn("[hsc] notify signup hit bot challenge:", r.url);
            swap("Couldn't verify — please try once more", false);
          } else if (r.ok || r.redirected) {
            swap("✓ We'll email you when it's back", true);
          } else {
            /* Surface the HTTP status so failures are diagnosable on sight. */
            console.warn("[hsc] notify signup failed:", r.status, r.url);
            swap("Couldn't sign you up (error " + r.status + ")", false);
          }
        }).catch(function (err) {
          console.warn("[hsc] notify signup network error:", err);
          swap("Couldn't sign you up — network error", false);
        });
      });
      return f;
    }

    /* ---- quick-view modal ---- */
    function setModalImage(i) {
      var item = mImgs[i];
      if (!item) return;
      mswitch.querySelectorAll("button").forEach(function (b) {
        b.classList.toggle("on", parseInt(b.dataset.i, 10) === i);
      });
      /* Quick cross-fade to the selected image. */
      mimg.style.opacity = "0";
      setTimeout(function () {
        mimg.src = item.src; mimg.alt = item.alt || "";
        mimg.style.opacity = "";
      }, 160);
    }
    mswitch.addEventListener("click", function (e) {
      var b = e.target.closest("button[data-i]");
      if (!b || b.classList.contains("on")) return;
      setModalImage(parseInt(b.dataset.i, 10));
    });

    function openModal(handle, maxq) {
      mOpener = document.activeElement;
      mHandle = handle;
      mMax = maxq; mn.textContent = "1";
      /* Clear any leftover Notify form from a previous sold-out product. */
      var mact = madd.parentNode;
      Array.prototype.slice.call(mact.querySelectorAll(".hsc-bisform,.hsc-bisok")).forEach(function (nd) {
        nd.parentNode.removeChild(nd);
      });
      mact.querySelector(".hsc-qty").hidden = false;
      madd.hidden = false;
      mtitle.textContent = "Loading…"; mprice.textContent = ""; mdesc.innerHTML = ""; mimg.src = "";
      mbadges.innerHTML = "";
      mImgs = []; mswitch.hidden = true; mswitch.classList.remove("nudge");
      mswitch.querySelectorAll("button").forEach(function (b) { b.classList.toggle("on", b.dataset.i === "0"); });
      mVariant = null; delete madd.dataset.variant;
      madd.disabled = true;
      madd.classList.remove("done", "busy", "ball", "caught", "incart", "hsc-notify");
      madd.textContent = addLabel();
      mback.classList.add("open"); modal.classList.add("open");
      document.documentElement.style.overflow = "hidden";
      fetch("/products/" + handle + ".js")
        .then(function (r) { return r.json(); })
        .then(function (p) {
          var d = norm(p);
          mtitle.textContent = shortName(d.title);
          mprice.textContent = money(d.priceCents);
          mdesc.innerHTML = p.description || "";
          if (d.img) { mimg.src = d.img; mimg.alt = d.title; }
          /* 2nd product image = the set's top chase card; the image's alt
             text ("Top Chase: …" / "Included Promo: …") picks the label. */
          var imgs = (p.images || []).map(function (im) { return im.src || im; });
          mImgs = [{ src: imgs[0] || "", alt: d.title }];
          if (imgs[1]) {
            var alt2 = (p.media && p.media[1] && p.media[1].alt) || "Top chase card";
            mImgs.push({ src: imgs[1], alt: alt2 });
            mswitch.querySelector('button[data-i="1"]').textContent =
              alt2.indexOf("Promo") > -1 ? "Promo Card" : "Top Chase";
            mswitch.hidden = false;
            mswitch.classList.add("nudge");
          }
          mbadges.innerHTML = badgesHtmlFor(d);
          mVariant = d.variantId;
          madd.disabled = false;
          if (d.available) {
            madd.dataset.variant = String(d.variantId);
            paintAddButton(madd);
          } else {
            /* Sold out: the button becomes a blue "Notify Me". */
            madd.classList.add("hsc-notify");
            madd.textContent = "Notify Me";
          }
          mclose.focus();
        })
        .catch(function () { mtitle.textContent = "Couldn’t load this product."; });
    }

    function closeModal() {
      if (!modal.classList.contains("open")) return;
      mback.classList.remove("open"); modal.classList.remove("open");
      document.documentElement.style.overflow = "";
      /* Return focus to whatever opened the modal (a11y). */
      if (mOpener && document.contains(mOpener) && typeof mOpener.focus === "function") {
        try { mOpener.focus(); } catch (e) { /* noop */ }
      }
      mOpener = null;
    }

    /* Keep keyboard focus inside the modal while it is open (a11y focus trap). */
    modal.addEventListener("keydown", function (e) {
      if (e.key !== "Tab" || !modal.classList.contains("open")) return;
      var els = modal.querySelectorAll("button:not(:disabled), a[href], input, [tabindex]:not([tabindex='-1'])");
      var list = [].filter.call(els, function (el) { return el.offsetParent !== null; });
      if (!list.length) return;
      var first = list[0], last = list[list.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
    mclose.addEventListener("click", closeModal);
    mback.addEventListener("click", closeModal);
    on(document, "keydown", function (e) { if (e.key === "Escape") closeModal(); });

    document.getElementById("hscMminus").addEventListener("click", function () {
      mn.textContent = Math.max(1, parseInt(mn.textContent, 10) - 1);
    });
    document.getElementById("hscMplus").addEventListener("click", function () {
      mn.textContent = Math.min(mMax, parseInt(mn.textContent, 10) + 1);
    });
    madd.addEventListener("click", function () {
      if (madd.classList.contains("hsc-notify")) {
        /* Sold out: swap the actions row for the email capture form. */
        var mact = madd.parentNode;
        mact.querySelector(".hsc-qty").hidden = true;
        madd.hidden = true;
        var f = bisNode(mHandle);
        mact.appendChild(f);
        f.querySelector("input").focus();
        return;
      }
      if (!mVariant) return;
      /* Close only after Shopify confirms the add; on failure the modal
         stays open so the "Try again" button is visible. */
      addToCart(mVariant, parseInt(mn.textContent, 10), madd, function () {
        setTimeout(closeModal, CONFIG.modalCloseMs);
      });
    });

    /* ---- product cards ---- */
    function card(p, cfg, i, maxq) {
      var el = document.createElement("article");
      el.className = "hsc-card rv";
      el.style.transitionDelay = (Math.min(i, 8) * 60) + "ms";
      var badgesInner = badgesHtmlFor(p);
      var badgesHtml = badgesInner ? '<span class="hsc-badges">' + badgesInner + '</span>' : "";
      el.innerHTML =
        '<a class="hsc-img" href="/products/' + p.handle + '">' +
          (p.img ? '<img loading="lazy" src="' + p.img + '" alt="' + p.title.replace(/"/g, "&quot;") + '">' : "") +
          badgesHtml +
          (p.available ? "" : '<span class="hsc-soldout">Sold out</span>') +
        '</a>' +
        '<div class="hsc-body">' +
          '<a class="hsc-name" href="/products/' + p.handle + '">' + shortName(p.title) + '</a>' +
          '<span class="hsc-meta">' + (cfg.meta || "&nbsp;") + '</span>' +
          '<span class="hsc-price">' + money(p.priceCents) + '</span>' +
          '<div class="hsc-row">' +
            '<div class="hsc-qty">' +
              '<button type="button" data-q="-1" aria-label="Decrease quantity">−</button>' +
              '<span data-n>1</span>' +
              '<button type="button" data-q="1" aria-label="Increase quantity">+</button>' +
            '</div>' +
            '<button type="button" class="hsc-add' + (p.available ? "" : " hsc-notify") + '" data-add="' + p.variantId + '" data-variant="' + p.variantId + '">' +
              (p.available ? addLabel() : "Notify Me") + '</button>' +
          '</div>' +
        '</div>';

      /* Image & title open the quick-view instead of navigating. */
      el.querySelectorAll("a").forEach(function (a) {
        a.addEventListener("click", function (ev) {
          ev.preventDefault();
          openModal(p.handle, maxq);
        });
      });

      var n = el.querySelector("[data-n]");
      el.querySelectorAll("[data-q]").forEach(function (b) {
        b.addEventListener("click", function () {
          n.textContent = Math.min(maxq, Math.max(1, parseInt(n.textContent, 10) + parseInt(b.dataset.q, 10)));
        });
      });

      var add = el.querySelector("[data-add]");
      if (p.available) {
        /* Reflect any quantity already in the cart when the card is built. */
        paintAddButton(add);
        add.addEventListener("click", function () {
          addToCart(add.dataset.add, parseInt(n.textContent, 10), add);
        });
      } else {
        /* Sold out: "Notify Me" swaps the row for the email capture form. */
        add.addEventListener("click", function () {
          var row = add.parentNode;
          row.innerHTML = "";
          var f = bisNode(p.handle);
          row.appendChild(f);
          f.querySelector("input").focus();
        });
      }
      return el;
    }

    /* ---- data loading + sorting (all from real data) ---- */
    function load(view) {
      /* Collections use Shopify's "Best selling" sort, so the order products
         arrive in IS the real sales-popularity ranking. */
      return fetch("/collections/" + CONFIG.collections[view] + "/products.json?limit=250")
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .then(function (d) {
          return d.products.map(function (p, i) {
            var np = norm(p);
            return { p: np, cfg: { meta: np.subtitle }, pop: i };
          });
        })
        .catch(function () { return []; });
    }

    function sortItems(list) {
      var l = list.slice(), s = sortSel.value;
      if (s === "new")             l.sort(function (a, b) { return b.p.createdAt - a.p.createdAt; });
      else if (s === "price-desc") l.sort(function (a, b) { return b.p.priceCents - a.p.priceCents; });
      else if (s === "price-asc")  l.sort(function (a, b) { return a.p.priceCents - b.p.priceCents; });
      else                         l.sort(function (a, b) { return a.pop - b.pop; }); /* best-selling */
      return l;
    }

    function paintGrid() {
      grid.innerHTML = "";
      grid.classList.toggle("singles", curView === "singles");
      var list = sortItems(lastItems);
      if (list.length) {
        list.forEach(function (item, i) {
          var c = card(item.p, item.cfg, i, CONFIG.maxQty[curView]);
          grid.appendChild(c); watch(c);
        });
      } else {
        var msg = CONFIG.emptyCopy[curView] || { h: "Nothing here yet.", p: "Check back soon." };
        var e = document.createElement("div");
        e.className = "hsc-empty rv";
        e.innerHTML = '<h3>' + msg.h + '</h3><p>' + msg.p + '</p>';
        grid.appendChild(e); watch(e);
      }
      wrap.classList.remove("fade");
    }

    sortSel.addEventListener("change", function () {
      wrap.classList.add("fade");
      setTimeout(paintGrid, 200);
    });

    function render(view) {
      curView = view;
      load(view).then(function (list) {
        lastItems = list;
        paintGrid();
      });
    }

    /* ---- tabs (event delegation on the segmented control) ---- */
    seg.addEventListener("click", function (e) {
      var b = e.target.closest("button[data-view]");
      if (!b || b.getAttribute("aria-pressed") === "true") return;
      var view = b.dataset.view;
      seg.dataset.view = view;
      seg.querySelectorAll("button").forEach(function (x) {
        x.setAttribute("aria-pressed", x === b ? "true" : "false");
      });
      if (window.history && history.replaceState) {
        var u = new URL(window.location.href);
        u.searchParams.set("view", view);
        history.replaceState(null, "", u.toString());
      }
      wrap.classList.add("fade");
      setTimeout(function () { render(view); }, 200);
    });

    var startView = (function () {
      var v = new URL(window.location.href).searchParams.get("view");
      return (v === "packs" || v === "singles") ? v : "boxes";
    })();
    seg.dataset.view = startView;
    seg.querySelectorAll("button").forEach(function (x) {
      x.setAttribute("aria-pressed", x.dataset.view === startView ? "true" : "false");
    });

    /* ---- external cart-change sync ---- */
    /* Instant path: hook fired by the global fetch watch (drawer edits). */
    window.__hscCartMutated = function () { syncCartSoon(true); };
    /* Belt-and-braces: common theme cart events. */
    ["cart:update", "cart:change", "cart:refresh", "cart:item-added", "cart-drawer:update"].forEach(function (ev) {
      on(document, ev, function () { syncCartSoon(true); });
    });
    /* Back-button (bfcache) / tab-focus re-sync — silent, no toast. */
    on(window, "pageshow", function (e) { if (e.persisted) syncCartSoon(false); });
    on(document, "visibilitychange", function () { if (!document.hidden) syncCartSoon(false); });
    on(window, "focus", function () { syncCartSoon(false); });

    /* ---- boot this instance ---- */
    madd.textContent = addLabel();
    render(startView);
    refreshCart(false);

    /* ---- cleanup (Theme Editor reloads) ---- */
    return function cleanup() {
      docListeners.forEach(function (l) { l[0].removeEventListener(l[1], l[2]); });
      clearTimeout(timers.toast);
      clearTimeout(timers.sync);
      if (io) io.disconnect();
      if (window.__hscCartMutated) window.__hscCartMutated = null;
      document.documentElement.style.overflow = "";
    };
  }

  /* ============================ boot ============================ */
  function boot() {
    var root = document.querySelector("[data-hsc-home]");
    if (!root) return;
    if (window.__hscCleanup) { window.__hscCleanup(); window.__hscCleanup = null; }
    window.__hscCleanup = init(root);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  /* Theme Editor: re-init when this section is re-rendered, clean up when
     it is removed. */
  document.addEventListener("shopify:section:load", function (e) {
    if (e.target && e.target.querySelector("[data-hsc-home]")) boot();
  });
  document.addEventListener("shopify:section:unload", function (e) {
    if (e.target && e.target.querySelector("[data-hsc-home]") && window.__hscCleanup) {
      window.__hscCleanup(); window.__hscCleanup = null;
    }
  });
})();